// extracted by mini-css-extract-plugin
export default {"table_wrapper":"ProjectsTable_table_wrapper__ZI-jz","table":"ProjectsTable_table__So3lB"};